import React from 'react'

import { Icon } from './Icon'

export const NotificationIcon = React.memo(({ className }: { className?: string }) => (
  <Icon size="16" viewBox="0 0 16 16" fill="none" color="currentColor" className={className}>
    <path
      d="M6.99997 0.666992C4.42264 0.666992 2.3333 2.75633 2.3333 5.33366C2.3333 7.56876 1.85526 8.95675 1.41471 9.76442C1.19351 10.17 0.978119 10.436 0.8285 10.5939C0.753517 10.6731 0.694594 10.7255 0.659117 10.7551C0.641369 10.7699 0.62973 10.7789 0.624598 10.7827L0.621826 10.7846C0.621826 10.7846 0.622031 10.7846 0.624598 10.7827L0.627028 10.7811L0.628509 10.7801L0.629316 10.7795C0.629316 10.7795 0.629449 10.7794 0.630955 10.7816L0.999969 12.0003H13L13.369 10.7816C13.3705 10.7794 13.3706 10.7795 13.3706 10.7795L13.3714 10.7801L13.3729 10.7811L13.3756 10.7828C13.3705 10.779 13.3586 10.7699 13.3408 10.7551C13.3053 10.7255 13.2464 10.6731 13.1714 10.5939C13.0218 10.436 12.8064 10.17 12.5852 9.76442C12.1447 8.95675 11.6666 7.56876 11.6666 5.33366C11.6666 2.75633 9.5773 0.666992 6.99997 0.666992Z"
      fill="black"
    />
    <path
      d="M4.99992 13.3337C4.99992 14.4382 5.89535 15.3337 6.99992 15.3337C8.10449 15.3337 8.99992 14.4382 8.99992 13.3337H4.99992Z"
      fill="black"
    />
  </Icon>
))
